import { useFormContext, useWatch } from "react-hook-form";
import { useGetLicenseCategories } from "../../repositories/licences-repository";
import { LoadingSkeleton } from "../fragments/service-offered-tile";
import CategoriesTile from "../fragments/categories-tile";

export default function LicenceActivitiesForm() {
    const {
        register,
        formState: { errors },
        setValue,
        control
    } = useFormContext();
    const selectedCategory = useWatch({
        control,
        name: "selectedCategory",
        defaultValue: ""
    });

    const { licence_categories, isLoading } = useGetLicenseCategories();

    const licencesActivities = licence_categories?.results?.map((el:any) => ({
        label: el.name,
        value: el.id,
    }));

    const handleCategorySelect = (id: string) => {
        if (selectedCategory === id) return;
        setValue("selectedCategory", id, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true
        });
    };

    if (isLoading) return <LoadingSkeleton />;

    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">License Activities</h1>
            <p className="text-xs text-gray-800">
                Select the categories of the services your business provides.
            </p>
            <div className="mt-3 grid grid-cols-1 gap-5">
                {licencesActivities?.map((el:any) => (
                    <CategoriesTile
                        key={el.value}
                        label={el.label}
                        name="selectedCategory"
                        register={() => register("selectedCategory", { 
                            required: "Please select a category" 
                        })}
                        clickEvent={() => handleCategorySelect(el.value)}
                        error={errors.selectedCategory?.message?.toString()}
                        isSelected={selectedCategory === el.value}
                    />
                ))}
            </div>
        </div>
    );
}